import ajax from '../http/ajax'
/**
 *
 * param {marketing_id: '', // 营销id } param
 */
export const getDistributionDetail = param => {
    return ajax.get('getDistributionDetail', param)
}
/**
 *
 * param {sstore_id: '', // 门店id
    goods_type: '', // 商品类型（proprietary:自营，agent：代理）
    goods_id: '', // 商品规格id
    spu_id: '', // 商品id} param
 */
export const getDistributionDetailSpecList = param => {
    return ajax.get('getDistributioGoodsSpecList', param)
}

/**
 * @param {*} param {
 *  goods_id: 规格id
 *  name: 门店名称
 *  longitude：经度
 *  latitude：纬度
 *  page:1
 *  pagesize: 10
 * }
 */
export const getDistributioStroreList = param => {
    return ajax.get('getDistributioStroreList', param)
}
